import { stateOptions } from '../commonStateTaxData';

export const basicInfoQuestions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '\\d{5}',
      },
    ],
  },
  {
    id: 'marital_status',
    title: 'Choose your marital status for your personal exemption',
    is_required: true,
    question_type: 'dropdown',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_spouse_unemployed',
        shortName: 'Married - spouse not employed',
      },
      {
        codeValue: 'married_spouse_employed',
        shortName: 'Married - spouse is employed',
      },
      {
        codeValue: 'head_of_family',
        shortName: 'Head of family',
      },
    ],
  },
];

export const sharedExemptionQuestions = [
  {
    id: 'additional_withholding_amount',
    title:
      'Additional dollar amount of withholding per pay period if agreed to by your employer (Line 7)',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
